module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-6acd27a3b509d8f8b70825f0f2671cb6.png";